import { dataTestIds } from '@velasca/constants'
import { CartIcon } from '@velasca/icons/cart'
import {
  QuickAddToCartButtonBackground,
  QuickAddToCartButtonIcon,
} from './QuickAddToCartButton.styles'
import type { QuickAddToCartButtonProps } from './QuickAddToCartButton.types'

export const QuickAddToCartButton = ({
  onClick,
  className = '',
}: QuickAddToCartButtonProps): JSX.Element => {
  return (
    <div className={className}>
      <QuickAddToCartButtonIcon
        iconSize="1.7rem"
        variant="secondary"
        clickAreaSize="3.2rem"
        onClick={onClick}
      >
        <QuickAddToCartButtonBackground
          data-testid={dataTestIds.QUICK_ADD_TO_CART_BUTTON}
        >
          <CartIcon />
        </QuickAddToCartButtonBackground>
      </QuickAddToCartButtonIcon>
    </div>
  )
}
